<template>
    <footer>
        <strong>Copyright © 2020 NIT.S4.7.</strong>
        <!-- <router-link to="friends">Friends</router-link> -->
    </footer>
</template>

<script>
    export default {
        name: 'site-footer'
    }
</script>

<style scoped>
    footer {
        margin-top: 10px;
        border-radius: 1%;
        background-color: #88dce9b9;
        opacity: 0.9;
        position: sticky;
    }
    @media (min-width: 768px) {
        footer {
            padding: 0;
            height: 0px;
            /* display: grid; */
        }
    }
    /* @media (min-width: 1024px) {
        footer {
            grid-template-columns: 1fr 980px 1fr;
        }
    } */
</style>
